export default "__VITE_ASSET__CEfaNJc___"